import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useStore, useStorePersist } from "store/context";

import { isMobile } from 'helpers/Mobile';
import useRequest from '../../hooks/useRequest';
import useDownloadStatus from 'hooks/useDownloadStatus';
import { useQuery } from 'hooks/useQuery';
import numberFormatter from 'hooks/numberFormatter';

import MainLayout from '../../components/Layouts/MainLayout';

import SearchSelect from '../../components/atoms/SearchSelect';
import Box from '../../components/atoms/Box';
import GradientButton from '../../components/atoms/GradientButton';
import { DESCARGADO_TITLE } from '../../components/atoms/DownloadIconButton';
import InputText from 'components/atoms/InputText';
import InputCheckbox from 'components/atoms/InputCheckbox';
import Modal from '../../components/atoms/Modal';
import Situacion from 'components/atoms/Situacion';
import Radio from 'react-bootstrap/FormCheck';

import { UnidadService } from '../../services/UnidadService';
import { FacturaService } from '../../services/FacturaService';
import Api from '../../services/ApiService';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import Form from 'react-bootstrap/Form';

import pagoOnline from 'assets/images/pago-online.png';
import redesConfianza from 'assets/images/redes-confianza.png';
import entidadesBancarias from 'assets/images/entidades-bancarias.png';
import credito from 'assets/images/credito.png';
import debito from 'assets/images/debito.png';
import debitoAutomatico from 'assets/images/debito-automatico.png';
import check from 'assets/images/check.png';

import './styles.scss';

const parseMontoDeuda = (value) => {
  if (value == null) {
    return null;
  }

  const parsed = parseFloat(String(value).trim().replace(',', '.'));
  return Number.isNaN(parsed) ? null : parsed;
};

const parseFechaDeuda = (value) => {
  if (value == null) {
    return null;
  }

  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
};

const HomeView = (props) => {
  const history = useHistory();
  const {
    currency
  } = numberFormatter();

  const {
    submitted, success, message, errors, loadingSpinner,
    beforeSubmit, afterSubmit, showSuccess, showError,
    dealWithError
  } = useRequest();

  const { getStatus, run } = useDownloadStatus();

  const query = useQuery();

  const [load, setLoad] = useStore(false);  // Esta variable sirve para cultar el front hasta tener la unidad.
  const [{
    uf,  // La uf actual seleccionada
  }, dispatch] = useStore();

  const [{
    unidades
  }, dispatchPersist] = useStorePersist();

  const [modoFD, setModoFD] = useState(1);  // 1=Adherir, 2=Dar de Baja, 3=Confirmar Dar de Baja
  const titleFactura = <>
    <strong>UF</strong> {uf.unidad} - {uf.alias} -
  </>;

  const titleDebito = <>
    <strong>UF</strong> {uf.unidad} - {uf.alias}
  </>;

  const [motivo, setMotivo] = useState("RECIBIR");
  const [comentario, setComentario] = useState("");

  const [ultimaFactura, setUltimaFactura] = useState({});

  const [showFD, setShowFD] = useState(false);
  const [showDA, setShowDA] = useState(false);
  const [showBajaDA, setShowBajaDA] = useState(false);
  const [showConfirmarBajaDA, setShowConfirmarBajaDA] = useState(false);

  const [hasAdherir, setHasAdherir] = useState();
  const [hasBaja, setHasBaja] = useState();
  const [checkDebitoFactura, setCheckDebitoFactura] = useState(true);
  const [checkDebitoPlan, setCheckDebitoPlan] = useState(true);
  const [hasDebitoPlan, setHasDebitoPlan] = useState();
  const [disableDebitoPlan, setDisableDebitoPlan] = useState();
  const [disableDebitoFactura, setDisableDebitoFactura] = useState();
  const [checkDebitoRadio, setCheckDebitoRadio] = useState();
  const [debitoFactura, setDebitoFactura] = useState(false);
  const [debitoPlan, setDebitoPlan] = useState(false);
  const [aceptaDescargaVencida, setAceptaDescargaVencida] = useState(false);

  useEffect(() => {
    getUnidades();
    setMotivo("RECIBIR");
  }, []);


  const getUnidades = () => {
    beforeSubmit();
    UnidadService.unidades({})
      .then((unidades) => {
        afterSubmit();
        if (unidades.length === 0) {
          history.push('/unidades_adheridas');
          return;
        }

        dispatchPersist({
          type: 'setUnidades',
          payload: unidades,
        });
        setLoad(true);
      }).catch((error) => {
        afterSubmit();
      });
  }

  useEffect(() => {
    if (!unidades || unidades.length === 0) {
      return;
    }

    const selected = uf
      ? unidades.find(u => u.id === uf.id || u.unidad === uf.unidad)
      : null;

    dispatch({
      type: 'setUf',
      payload: selected || unidades[0],
    });
  }, [unidades]);

  useEffect(() => {
    if (!uf) {
      return;
    }

    beforeSubmit();

    UnidadService.estadoDebito(uf.id).then(data => {
      const missOne = !(data['debito_fac'] && (data['debito_plan'] || data['has_plan']));
      setCheckDebitoRadio(missOne);
      setHasBaja(data['debito_fac'] || data['debito_plan']);
      setHasAdherir(missOne);
      setHasDebitoPlan(data['has_plan'])
      updateDisabledDebito(data);
      afterSubmit();
    }).catch((error) => {
      afterSubmit();
      dealWithError(error, '');
    });

    UnidadService.ultimaFactura(uf.id).then(data => {
      setUltimaFactura({
        fec_vto1: data.fec_vto1,
        saldo: data.saldo,
        per_has: data.per_has,
        comprobante: data.tpo_com + '-' + data.pre_com + '-' + String(data.num_com).padStart(8, '0'),
        p_debaut: data.p_debaut,
      });
      afterSubmit();
    }).catch((error) => {
      afterSubmit();
      dealWithError(error, '');
    });
  }, [uf && uf.id]);

  const handleAdherirFD = () => {
    beforeSubmit();

    FacturaService.adherirFD(uf.id)
      .then(data => {
        afterSubmit();
        dispatch({
          type: 'setUf',
          payload: data,
        });
        handleCloseFD();
      }).catch((error) => {
        afterSubmit();
        dealWithError(error, '');
        //
        // MOSTRAR ERROR
        //
      });
  }

  const handleBajaFD = () => {
    setModoFD(3);
    setMotivo("RECIBIR");  //Setear el default
    setComentario("");  //Setear el default
  }

  const handleConfirmarBajaFD = () => {
    setModoFD(4);
  }

  const handleSubmitConfirmBajaFD = (e) => {
    e.preventDefault();
    const data = {
      motivo: motivo,
      comentario: comentario
    }

    beforeSubmit();
    FacturaService.bajaFD(uf.id, data)
      .then(data => {
        afterSubmit();
        dispatch({
          type: 'setUf',
          payload: data,
        });
        handleCloseFD();
      }).catch((error) => {
        afterSubmit();
        dealWithError(error, '');
        //
        // MOSTRAR ERROR
        //
      });
  }

  const handleShowFD = () => {
    setModoFD(uf.factura_digital ? 2 : 1);
    setShowFD(true);
  }

  const action = () => {
    console.log('action');
  }

  const descargarFactura = () => {
    console.log('action');
  }

  const onCheckPlanChange = () => {
    setCheckDebitoPlan(!checkDebitoPlan);
  }

  const onCheckFacturaChange = () => {
    setCheckDebitoFactura(!checkDebitoFactura);
  }

  const onDebitoChange = () => {
    setDisableDebitoFactura(!disableDebitoFactura);
    setDisableDebitoPlan(!disableDebitoPlan || !hasDebitoPlan);
    setCheckDebitoRadio(!checkDebitoRadio);
    setCheckDebitoFactura(false);
    setCheckDebitoPlan(false);
  }

  const updateDisabledDebito = (data) => {
    const adherirSelected = !(data['debito_fac'] && (data['debito_plan'] || !data['has_plan']));
    console.log(adherirSelected);
    setDebitoFactura(data['debito_fac']);
    setDebitoPlan(data['debito_plan']);
    if (adherirSelected) {
      console.log("adehrir");
      setDisableDebitoFactura(data['debito_fac']);
      setDisableDebitoPlan(!data['has_plan'] || data['debito_plan']);
    }
    else {
      console.log("dar de baja");
      setDisableDebitoFactura(!data['debito_fac']);
      setDisableDebitoPlan(!data['has_plan'] || !data['debito_plan']);
    }
  }

  const handleShowDA = () => {
    UnidadService.estadoDebito(uf.id).then(data => {
      const missOne = !(data['debito_fac'] && (data['debito_plan'] || !data['has_plan']));
      setCheckDebitoRadio(missOne);
      setHasBaja(data['debito_fac'] || data['debito_plan']);
      setHasAdherir(missOne);
      setHasDebitoPlan(data['has_plan'])
      updateDisabledDebito(data);
    }).catch((error) => {
      afterSubmit();
      dealWithError(error, '');
    });
    setShowDA(true);
  }

  const handleDebitoAutomatico = () => {
    if (!checkDebitoFactura && !checkDebitoPlan) {
      alert("No se puede adherir");
    }
    else {
      if (checkDebitoRadio) {
        const debitoFactura = (checkDebitoFactura && !disableDebitoFactura) ? 1 : 0;
        const debitoPlan = (checkDebitoPlan && !disableDebitoPlan) ? 2 : 0;
        const ambosDebitos = debitoFactura + debitoPlan;
        history.push('/alta-debito/' + uf.id + '/' + ambosDebitos);
      }
      else {
        handleCloseDA();
        setShowBajaDA(true);
        setMotivo("tarjeta_incorrecta");  //Setear el default
        setComentario("");  //Setear el default
      }
    }
  }

  const handleDebitoBaja = (e) => {
    e.preventDefault();
    beforeSubmit();
    const debitoFactura = (checkDebitoFactura && !disableDebitoFactura) ? 1 : 0;
    const debitoPlan = (checkDebitoPlan && !disableDebitoPlan) ? 2 : 0;
    const data = {
      campo: debitoFactura + debitoPlan,
      motivo: motivo,
      comentario: comentario
    }
    UnidadService.bajaDebito(data, uf.id)
      .then(data => {
        afterSubmit();
        handleCloseDA();
        handleCloseBajaDA();
        setShowConfirmarBajaDA(true);
        UnidadService.estadoDebito(uf.id).then(data => {
          const missOne = !(data['debito_fac'] && (data['debito_plan'] || !data['has_plan']));
          setCheckDebitoRadio(missOne);
          setHasBaja(data['debito_fac'] || data['debito_plan']);
          setHasAdherir(missOne);
          setHasDebitoPlan(data['has_plan'])
          updateDisabledDebito(data);
        }).catch((error) => {
          afterSubmit();
          dealWithError(error, '');
        });
      }).catch((error) => {
        dealWithError(error, '');
      });
  }

  const handleCloseFD = () => {
    setShowFD(false);
  }

  const handleCloseDA = () => {
    setShowDA(false);
  }

  const handleCloseBajaDA = () => {
    setShowBajaDA(false);
  }

  const handleCloseConfirmarBajaDA = () => {
    setShowConfirmarBajaDA(false);
  }

  const handleChange = (nroUnidad) => {
    const filtrada = unidades.find(u => u.unidad === nroUnidad);
    if (!filtrada) {
      return;
    }

    dispatch({
      type: 'setUf',
      payload: filtrada,
    });

    UnidadService.unidad(filtrada.id)
      .then(data => {
        dispatch({
          type: 'setUf',
          payload: {
            ...filtrada,
            ...data,
            val_atr_26: data.val_atr_26 != null && data.val_atr_26 !== '' ? data.val_atr_26 : filtrada.val_atr_26,
            val_atr_27: data.val_atr_27 != null && data.val_atr_27 !== '' ? data.val_atr_27 : filtrada.val_atr_27,
          },
        });
      }).catch((error) => {
        dealWithError(error, '');
      });
  };

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  const bodyFDAdherir = <span className="adherir-body">
    <h3>FACTURA DIGITAL</h3>
    {uf.factura_digital &&
      <span className="adherido">ADHERIDO <img src={check}></img></span>}
    {!uf.factura_digital &&
      <span className="no-adherido">NO ADHERIDO</span>}
    <GradientButton legend={'ADHERIR'} handleClick={handleAdherirFD} />
  </span>;

  const bodyFDBaja = <span className="baja-body">
    <h3>BAJA FACTURA DIGITAL</h3>
    {uf.factura_digital &&
      <span className="adherido">ADHERIDO <img src={check}></img></span>}
    {!uf.factura_digital &&
      <span className="no-adherido">NO ADHERIDO</span>}
    <GradientButton legend={'DAR DE BAJA'} handleClick={handleBajaFD} />
  </span>;

  const bodyFDMotivoBaja = <span className="confirmar-baja-body">
    <h3>BAJA FACTURA DIGITAL</h3>
    <div className="confirmar-baja-container">
      <div className="confirmar-baja-content">
        <form className="confirmar-baja-form" onSubmit={handleConfirmarBajaFD}>
          <div className="confirmar-baja-input-group">
            <div className="confirmar-baja-input-container">
              <span>
                <div class="input-text-container">
                  <Form.Group controlId="dropdown-uf-select">
                    <Form.Label>MOTIVO</Form.Label>
                    <Form.Control as="select" size="lg" custom value={motivo}
                      onChange={(event) => { setMotivo(event.target.value) }} >
                      <option key={"RECIBIR"} value="RECIBIR">Deseo Recibir Factura Papel</option>
                      <option key={"VENTA"} value="VENTA">Venta de la Propiedad</option>
                      <option key={"VISUALIZAR"} value="VISUALIZAR">La factura me llega pero no la puedo visualizar</option>
                      <option key={"NOLLEGA"} value="NOLLEGA">No me llega la Factura a mi correo electrónico</option>
                      <option key={"OTROS"} value="OTROS">Otros</option>
                    </Form.Control>
                  </Form.Group>
                </div>
              </span>
            </div>
          </div>
          <div className="confirmar-baja-input-group">
            <div className="confirmar-baja-input-container">
              {motivo === "OTROS" && <InputText id="comentarios" label="COMENTARIOS" type="text" handleChange={(event) => { setComentario(event.target.value) }} error={errors.comentario} />}
            </div>
          </div>
          {(success === false && message) &&
            <p className="error-messages">{message}</p>
          }
          <div className="confirmar-baja-button">
            <GradientButton legend={'CONTINUAR'} handleClick={handleConfirmarBajaFD} />
          </div>
        </form>
      </div>
    </div>
  </span>;

  const bodyFDConfirmBaja = <span className="confirmar-baja-body">
    <h3>FACTURA DIGITAL</h3>
    <div className="confirmar-baja-container">
      <div className="confirmar-baja-content baja-confirmar">
        <span className="adherido">ADHERIDO <img src={check}></img></span>

        <p className="confirmar-baja-mensaje">¿Realmente querés dar de baja la Factura Digital?</p>
        {(success === false && message) &&
          <p className="error-messages">{message}</p>
        }
        <div className="confirmar-baja-button">
          <GradientButton legend={'DAR DE BAJA'} handleClick={handleSubmitConfirmBajaFD} />
        </div>
      </div>
    </div>
  </span>;

  const bodyDebito = <span className="adherir-debito-body">
    <h3>DÉBITO AUTOMÁTICO</h3>
    <Radio inline name="debitoOperacion" type='radio' onClick={onDebitoChange} checked={checkDebitoRadio} label='Adherir' id="debito-adherir" disabled={!hasAdherir} />
    <Radio inline name="debitoOperacion" type='radio' onClick={onDebitoChange} checked={!checkDebitoRadio} label='Dar de baja' id="debito-plan" disabled={!hasBaja} />
    <InputCheckbox checked={(checkDebitoFactura || disableDebitoFactura)} handleChange={onCheckFacturaChange} legend={'Factura'} value={'F'} disabled={disableDebitoFactura} />
    <InputCheckbox checked={(checkDebitoPlan || disableDebitoPlan)} handleChange={onCheckPlanChange} legend={'Plan de Financiación'} value={'P'} disabled={disableDebitoPlan} />
    <GradientButton legend={'CONTINUAR'} handleClick={handleDebitoAutomatico} disabled={!(checkDebitoFactura && checkDebitoFactura)} />
  </span>;

  const bodyBajaDebito = <span className="confirmar-baja-body">
    <h3>BAJA DÉBITO AUTOMÁTICO</h3>
    <div className="confirmar-baja-container">
      <div className="confirmar-baja-content">
        <form className="confirmar-baja-form" onSubmit={handleDebitoBaja}>
          <div className="confirmar-baja-input-group">
            <div className="confirmar-baja-input-container">
              <span>
                <div className="input-text-container">
                  <Form.Group controlId="dropdown-motivo-select">
                    <Form.Label>MOTIVO</Form.Label>
                    <Form.Control as="select" size="lg" custom onChange={(event) => { setMotivo(event.target.value) }}>
                      <option key={"TARJETA_INCORRECTA"} value="TARJETA_INCORRECTA">Número de tarjeta o cuenta incorrecto</option>
                      <option key={"TARJETA_BAJA"} value="TARJETA_BAJA">Tarjeta o cuenta dada de baja</option>
                      <option key={"TARJETA_INHABILITADA"} value="TARJETA_INHABILITADA">Tarjeta o cuenta inhabilitada</option>
                      <option key={"CUENTA_CERRADA"} value="CUENTA_CERRADA">Cuenta cerrada</option>
                      <option key={"OTROS"} value="OTROS">Otros</option>
                    </Form.Control>
                  </Form.Group>
                </div>
              </span>
            </div>
          </div>
          <div className="confirmar-baja-input-group">
            <div className="confirmar-baja-input-container">
              {motivo === "OTROS" && <InputText id="comentarios" label="COMENTARIOS" type="text" handleChange={(event) => { setComentario(event.target.value) }} error={errors.comentario} />}
            </div>
          </div>
          {(success === false && message) &&
            <p className="error-messages">{message}</p>
          }
          <div className="confirmar-baja-button">
            <GradientButton legend={'DAR DE BAJA'} handleClick={handleDebitoBaja} />
          </div>
        </form>
      </div>
    </div>
  </span>;

  const bodyConfirmarBajaDebito = <span className="confirmar-baja-body">
    <h3>DÉBITO AUTOMÁTICO</h3>
    <div className="confirmar-baja-container">
      <div className="confirmar-baja-content baja-confirmar">

        {(checkDebitoFactura && !checkDebitoPlan) && <p className="confirmar-baja-mensaje">La Unidad fue dada de baja al débito automático de facturas.</p>}
        {(!checkDebitoFactura && checkDebitoPlan) && <p className="confirmar-baja-mensaje">La Unidad fue dada de baja al débito automático de planes de financiación.</p>}
        {(checkDebitoFactura && checkDebitoPlan) && <p className="confirmar-baja-mensaje">La Unidad fue dada de baja al débito automático de facturas y planes de financiación.</p>}

        <div className="confirmar-baja-button">
          <GradientButton legend={'CERRAR'} handleClick={handleCloseConfirmarBajaDA} />
        </div>
      </div>
    </div>
  </span>;

  let bodyFD;
  switch (modoFD) {
    case 1:
      bodyFD = bodyFDAdherir;
      break;
    case 2:
      bodyFD = bodyFDBaja;
      break;
    case 3:
      bodyFD = bodyFDMotivoBaja;
      break;
    case 4:
      bodyFD = bodyFDConfirmBaja;
      break;
  }

  /*

  Usar "load" para ocultar todo momentaneamente por si no tiene unidades y hay que redireccionar

  */

  const parsearComprobante = (comprobante) => {
    // Formato: "FC-0114-00012345"
    const partes = comprobante.split('-');
    if (partes.length !== 3) {
      return { tpo_com: '', pre_com: '', num_com: 0 };
    }
    return {
      tpo_com: partes[0],
      pre_com: partes[1],
      num_com: parseInt(partes[2], 10)
    };
  }

  const formatDateFactura = (date) => {
    const d = new Date(date);
    const month = '' + (d.getUTCMonth() + 1);
    const day = '' + d.getUTCDate();
    const year = d.getUTCFullYear();

    const monthFormatted = month.length < 2 ? '0' + month : month;
    const dayFormatted = day.length < 2 ? '0' + day : day;

    return [dayFormatted, monthFormatted, year].join('/');
  }

  const gestionarDeuda = (e) => {
    e.preventDefault();
    history.push('/consulta_descarga_facturas');
  }

  const pagarAhora = (e) => {
    e.preventDefault();

    // Validar que ultimaFactura tenga datos válidos
    if (!ultimaFactura || Object.keys(ultimaFactura).length === 0 || !ultimaFactura.comprobante || ultimaFactura.saldo === undefined || ultimaFactura.saldo <= 0) {
      return;
    }

    // Parsear el comprobante
    const comprobanteParsed = parsearComprobante(ultimaFactura.comprobante);

    // Calcular estado de la factura (comparar fechas en UTC)
    const d = ultimaFactura.fec_vto1 ? new Date(ultimaFactura.fec_vto1) : new Date();
    const hoy = new Date();
    const vtoUTC = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    const hoyUTC = Date.UTC(hoy.getUTCFullYear(), hoy.getUTCMonth(), hoy.getUTCDate());
    const estado = vtoUTC < hoyUTC ? 'Vencida' : 'Por Vencer';

    // Mapear tipos de comprobante
    const tipos = {
      "NC": "Nota de Credito",
      "FC": "Facturas",
      "FCPF": "Facturas Plan de Financiación",
      "PCR": "Pago Duplicado",
      "PCRM": "Plata a Cuenta"
    };
    const tipo_full = tipos[comprobanteParsed.tpo_com.trim()] || comprobanteParsed.tpo_com;

    // Crear objeto factura completo
    const factura = {
      tpo_com: comprobanteParsed.tpo_com,
      pre_com: comprobanteParsed.pre_com,
      num_com: comprobanteParsed.num_com,
      comprobante: ultimaFactura.comprobante,
      s_periodo: ultimaFactura.per_has || '',
      fec_ven: ultimaFactura.fec_vto1 ? formatDateFactura(ultimaFactura.fec_vto1) : '',
      total_bas: ultimaFactura.saldo,
      s_tot_recargo: 0,
      ajustado: ultimaFactura.saldo,
      estado: estado,
      isChecked: true,
      visible: true,
      seleccionable: ultimaFactura.p_debaut === "N" && uf.pagable,
      tipo_full: tipo_full,
      descargable: true
    };

    // Actualizar el store con la factura vigente
    dispatch({
      type: 'setFacturas',
      payload: [factura]
    });

    // Limpiar facturasLastUf para que ConsultaYDescargaView siempre recargue todas las facturas
    dispatch({
      type: 'setFacturasLastUf',
      payload: null
    });

    // Navegar a metodos_pagos
    history.push('/metodos_pagos');
  }

  const isFacturaVencida = () => {
    if (!ultimaFactura.fec_vto1) {
      return false;
    }
    const d = new Date(ultimaFactura.fec_vto1);
    const hoy = new Date();
    const vtoUTC = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    const hoyUTC = Date.UTC(hoy.getUTCFullYear(), hoy.getUTCMonth(), hoy.getUTCDate());
    return vtoUTC < hoyUTC;
  }

  const descargaKey = () => `ultima|${uf?.unidad}|${ultimaFactura?.comprobante}`;

  const handleDescargarFactura = () => {
    const vencida = isFacturaVencida();
    if (!vencida || aceptaDescargaVencida) {
      run(descargaKey(), () => Api.openAuthenticatedDownload(
        Api.comprobantePdfUrl(uf.unidad, ultimaFactura.comprobante, ultimaFactura.per_has)
      ))
        .catch((error) => {
          dealWithError(error, 'Error al obtener comprobantes');
        });
    }
  }

  const consumo = (e) => {
    e.preventDefault();
    history.push('/consumos');
  }

  const montoDeuda = parseMontoDeuda(uf?.val_atr_27);
  const fechaDeuda = parseFechaDeuda(uf?.val_atr_26);
  const tieneDeuda = montoDeuda != null && montoDeuda > 0;

  let deudaPrincipal;
  if (tieneDeuda) {
    const etiquetaFecha = fechaDeuda ? ` al ${fechaDeuda}` : '';
    deudaPrincipal = (
      <div className="deuda-item total w-100">
        <h4 className="deuda-label">
          Importe estimado{etiquetaFecha}:
          <span className="deuda-monto total">$ {currency.format(montoDeuda)}</span>
        </h4>
      </div>
    );
  } else if (montoDeuda === null) {
    deudaPrincipal = <h3 className="h3 text-center text-muted">Sin información de deuda</h3>;
  } else {
    deudaPrincipal = <h3 className="h3 text-center text-success">Tu unidad está al día</h3>;
  }

  return <> <MainLayout>
    {unidades && <SearchSelect onChange={handleChange} options={unidades} value={uf}></SearchSelect>}
    <div className="home-boxes">
      <Box header="DATOS SUMINISTRO" body={<div className="datos-suministros">
        <div className="datos-suministro datos-partida-usuario">
          <div className="partida-usuario">
            <h4>PARTIDO/PARTIDA</h4>
            <p>{uf.partido_partida}</p>
          </div>
          <div className="partida-usuario">
            <h4>TIPO DE USUARIO</h4>
            <p>Residencial</p>
          </div>
          {!isMobile && <Situacion situacion={uf.situacion} situacionCompleta={uf.situacion_completa}></Situacion>}
        </div>
        <div className="datos-suministro">
          <h4>DATOS DEL USUARIO</h4>
          <h4><strong>{uf.nombre_usuario}</strong></h4>
          <p>{uf.direccion_usuario}</p>
          <p className="direccion"></p>
        </div>
        <div className="datos-suministro">
          <h4>DATOS DEL PROPIETARIO</h4>
          <h4><strong>{uf.razon_social}</strong></h4>
          <p>{uf.direccion}</p>
        </div>
        {isMobile && <Situacion situacion={uf.situacion} situacionCompleta={uf.situacion_completa}></Situacion>}
        <div className="datos-suministro">
          <GradientButton legend={'VER CONSUMO'} handleClick={consumo} />
        </div>
      </div>} ></Box>
    </div>


    <div className="home-boxes">
      <div className="home-col deuda-col">
        <div className="home-boxes">
          <Box header="DEUDA" body={
            <div className="deuda d-flex flex-column">
              <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{ flexGrow: "1" }}>
                {deudaPrincipal}
              </div>
              {(tieneDeuda && uf.pagable) && (
                <div className="w-100 d-flex justify-content-end align-items-end">
                  <GradientButton legend={'GESTIONAR DEUDA'} handleClick={gestionarDeuda} className="px-2" />
                </div>
              )}
            </div>
          } ></Box>
        </div>
        <div className="home-boxes debito-factura">
          <Box header="DÉBITO AUTOMÁTICO" body={
            <div className="debito-automatico">
              <div className="debito-automatico-item">
                <p className="debito-automatico-label">Facturas</p>
                {debitoFactura &&
                  <span className="adherido">ADHERIDO <img src={check}></img></span>}
                {!debitoFactura &&
                  <span className="no-adherido">NO ADHERIDO</span>}
              </div>
              <div className="debito-automatico-item">
                <p className="debito-automatico-label">Plan de Financiación</p>
                {debitoPlan &&
                  <span className="adherido">ADHERIDO <img src={check}></img></span>}
                {!debitoPlan &&
                  <span className="no-adherido">NO ADHERIDO</span>}
              </div>
              <div className="debito-automatico-button">
                <GradientButton legend={'ACCEDER'} handleClick={handleShowDA} />
              </div>
            </div>
          } ></Box>
          <Box header="FACTURA DIGITAL" body={
            <div className="factura-digital">
              <div className="factura-digital-item">
                <p className="factura-digital-label">Factura</p>
                {uf.factura_digital &&
                  <span className="adherido">ADHERIDO <img src={check}></img></span>}
                {!uf.factura_digital &&
                  <span className="no-adherido">NO ADHERIDO</span>}
              </div>
              <div className="factura-digital-button">
                <GradientButton legend={'ACCEDER'} handleClick={handleShowFD} />
              </div>
            </div>
          } ></Box>
        </div>
      </div>
      <div className="home-col ultima-factura">
        <div className="home-boxes" style={ultimaFactura && ultimaFactura.saldo > 0 ? { height: "482px" } : {}}>
          <Box header="FACTURA VIGENTE" bodyClassName="h-100" body={
            (() => {
              // Caso 1: ultimaFactura vacío o sin información
              if (!ultimaFactura || Object.keys(ultimaFactura).length === 0 || ultimaFactura.saldo === undefined) {
                return (
                  <div className="d-flex flex-column h-100 justify-content-center align-items-center">
                    <p className="text-center m-0 text-info h3">No se ha encontrado información al respecto</p>
                  </div>
                );
              }

              // Caso 2: saldo == 0 (al día)
              if (ultimaFactura.saldo === 0) {
                return (
                  <div className="d-flex flex-column h-100 justify-content-center align-items-center">
                    <p className="text-center text-success h3">Estás al día con tus facturas</p>
                  </div>
                );
              }

              // Caso 3: saldo > 0 (mantener lógica actual + botón Pagar ahora)
              return (
                <div className="d-flex flex-column align-items-center justify-content-center h-100 position-relative">
                  <div className="factura-vigente-content d-flex flex-column align-items-center justify-content-center">
                    <div className="text-center">
                      <h4>VENCIMIENTO</h4>
                      <p>
                        {!loadingSpinner && (
                          <>
                            {ultimaFactura.fec_vto1
                              ? new Date(ultimaFactura.fec_vto1).toLocaleDateString('es-AR', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' })
                              : ''}
                          </>
                        )}
                      </p>
                    </div>
                    <div className="text-center">
                      <h4>TOTAL</h4>
                      <p>{!loadingSpinner && <>$ {currency.format(ultimaFactura.saldo)} </>}</p>
                    </div>
                    <div className="text-center">
                      <h4>PERIODO</h4>
                      <p>{!loadingSpinner && <>{ultimaFactura.per_has} </>}</p>
                    </div>
                    {isFacturaVencida() && (
                      <Alert variant="warning" className="mt-3">
                        <div className="d-flex align-items-center">
                          <InputCheckbox
                            checked={aceptaDescargaVencida}
                            handleChange={() => setAceptaDescargaVencida(!aceptaDescargaVencida)}
                            legend=""
                          />
                          <span className="ml-2">La factura que va a descargar esta vencida, puede abonarla por medios de pago electrónicos</span>
                        </div>
                      </Alert>
                    )}
                  </div>
                  <div className="factura-vigente-buttons">
                    <div className="descarga">
                      <GradientButton
                        legend={{ idle: 'DESCARGAR', loading: 'DESCARGANDO...', done: 'DESCARGADO' }[getStatus(descargaKey())]}
                        handleClick={handleDescargarFactura}
                        disabled={(isFacturaVencida() && !aceptaDescargaVencida) || getStatus(descargaKey()) !== 'idle'}
                        title={getStatus(descargaKey()) === 'done' ? DESCARGADO_TITLE : undefined}
                      />
                    </div>
                    {ultimaFactura.p_debaut === "N" && uf.pagable && <GradientButton legend={'PAGAR AHORA'} handleClick={pagarAhora} />}
                  </div>
                </div>
              );
            })()
          } ></Box>
        </div>
      </div>
      <div className="home-col formas-pago">
        <div className="home-boxes">
          <Box header="FORMAS DE PAGO" body={
            <div className="formas-pago-accordion">
              <Accordion>
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                      <img src={pagoOnline}></img> PAGO ONLINE
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <p>VISA Home</p>
                      <p>Link Pagos</p>
                      <p>Pagos Mis Cuentas</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey="1">
                      <img src={debito}></img> TARJETA DE DÉBITO
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <p>VISA Electrón</p>
                      <p>Maestro</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey="2">
                      <img src={credito}></img> TARJETA DE CRÉDITO
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <p>Visa</p>
                      <p>Mastercard</p>
                      <p>American Express</p>
                      <p>Cabal</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey="3">
                      <img src={debitoAutomatico}></img> DÉBITO AUTOMÁTICO
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body>
                      <p>En tarjeta de crédito</p>
                      <p>En cuenta bancaria</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey="4">
                      <img src={entidadesBancarias}></img> ENTIDADES BANCARIAS
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="4">
                    <Card.Body>
                      <p>Banco Credicoop</p>
                      <p>Banco de la Provincia de Buenos Aires</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey="5">
                      <img src={redesConfianza}></img> REDES DE COBRANZA
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="5">
                    <Card.Body>
                      <p>Pago Fácil</p>
                      <p>Provincia Net</p>
                      <p>Rapipago</p>
                      <p>Cobro Express</p>
                      <p>Ripsa</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          } ></Box>
        </div>
      </div>
    </div>
  </MainLayout>
    <Modal className="modal-factura-digital" title={titleFactura} body={bodyFD} legend={"ACCEDER"} action={action} handleClose={handleCloseFD} show={showFD}></Modal>
    <Modal className="modal-debito-automatico" title={titleDebito} body={bodyDebito} legend={"CONTINUAR"} action={action} handleClose={handleCloseDA} show={showDA}></Modal>
    <Modal className="modal-debito-automatico" title={titleDebito} body={bodyBajaDebito} legend={"DAR DE BAJA"} action={action} handleClose={handleCloseBajaDA} show={showBajaDA}></Modal>
    <Modal className="modal-debito-automatico" title={titleDebito} body={bodyConfirmarBajaDebito} legend={""} action={action} handleClose={handleCloseConfirmarBajaDA} show={showConfirmarBajaDA}></Modal>
  </>;
}

export default withTranslation()(HomeView);